<template>
    <Img
        v-if="url"
        :data-src="url"
        :alt="title"
        :class="classes"
        :width="width"
        :height="height"
        class="l-section__img"
    ></Img>
</template>

<script>
import Img from 'templates/objects/Img';

export default {
    name: 'block-image',
    components: {
        Img,
    },
    props: {
        url: {
            type: String,
        },
        title: {
            type: String,
        },
        classes: {
            type: String,
        },
        width: {
            type: String,
        },
        height: {
            type: String,
        },
        type: {
            type: String,
        },
    },
};
</script>
